import React, { createContext, useContext } from "react";
import type { TravellerDetailsV2InjectedProps } from "../TravellerDetailsV2.types";

const TravellerDetailsV2Context = createContext<
  TravellerDetailsV2InjectedProps | undefined
>(undefined);

export const useTravellerDetailsContext = (): TravellerDetailsV2InjectedProps => {
  const ctx = useContext(TravellerDetailsV2Context);
  if (!ctx) {
    throw new Error(
      "useTravellerDetailsContext must be used within TravellerDetailsV2Provider",
    );
  }
  return ctx;
};

export type TravellerDetailsV2ProviderProps = TravellerDetailsV2InjectedProps & {
  children: React.ReactNode;
};

/** Pass-through provider; form + buy orchestration lives in TravellerDetailsV2WithForm. */
export const TravellerDetailsV2Provider: React.FC<TravellerDetailsV2ProviderProps> = ({
  children,
  ...value
}) => (
  <TravellerDetailsV2Context.Provider value={value as TravellerDetailsV2InjectedProps}>
    {children}
  </TravellerDetailsV2Context.Provider>
);
